var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfographicLeftChev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 96,
    viewBox: "0 0 23 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.74228e-07L21 48L1 96",
    stroke: "url(#paint0_linear_4850_43281)",
    strokeWidth: 2,
    transform: "rotate(180 11.5 48)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4850_43281",
    x1: 11,
    y1: 4.37114e-7,
    x2: 11,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C6181",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500015,
    stopColor: "#4C6181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C6181",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfographicLeftChev);
export default __webpack_public_path__ + "static/media/infographic-left-chev.970ab7ef076563145428ad0778912e4a.svg";
export { ForwardRef as ReactComponent };